// extracted by mini-css-extract-plugin
module.exports = {"main":"ServiceContent_main__xKjSa","foldMin":"ServiceContent_foldMin__USlim"};